export class EnvironmentService {
  public clientId = '';
  public authorityEmpresas = '';
  public authorityWindows = '';
  public authorityPersonas = '';
  public apiUrl = '';
  public apiUrlCafam = '';
  public cafamLoginURL = '';
  public cafamHomeURL = '';
  public appReturnURL = '';
  public tvURL = '';
  public ConsultaEmpresasCA = '';
  public ConsultaEmpresasCA_Authorization = '';
  public ConsultaEmpresasCA_OcpApim = '';
  public appVisorURL = '';
  public profileImageRelation = [];
  public tocid = '';
  public showDocumentViewer = false;
  public adminSite = false;
  public subsidioGroupName = '';
  public consultaGroupName = '';
  public adminGroupName = '';
  public urlPdf = '';
  public codigosHistorial = [];
  public htmlFormAfiliaNoDepende ="";
  public htmlFormAfiliaEmpleador ="";
  public htmlFormFueraHorario = "";
  constructor() {}
}
